/**
 * deviceLIst에 현재 기기 model과 os가 들어있는 지 확인합니다.
 * @param userAgentStr userAgent raw string
 * @param deviceList feature에 등록된 `${{deviceName}/${osVersion}` 배열
 * @returns
 */
export function isMatchModelAndOs(
  userAgentStr: string,
  deviceList: Array<string>
): boolean {
  if (!userAgentStr || !Array.isArray(deviceList)) {
    return false;
  }
  return deviceList.some(item => {
    const [model, os] = item.trim().split('/');
    if (!model || !os) {
      return false;
    }
    const isMatchModel =
      model === '*' || userAgentStr.search(new RegExp(model, 'i')) >= 0;
    const isMatchOs =
      os === '*' || userAgentStr.search(new RegExp(os, 'i')) >= 0;
    return isMatchModel && isMatchOs;
  });
}
